/**
* @license Apache-2.0
*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //

import arcsine from './../../base/dists/arcsine/cdf';
import beta from './../../base/dists/beta/cdf';
import betaprime from './../../base/dists/betaprime/cdf';
import cauchy from './../../base/dists/cauchy/cdf';
import chi from './../../base/dists/chi/cdf';
import chisquare from './../../base/dists/chisquare/cdf';
import cosine from './../../base/dists/cosine/cdf';
import erlang from './../../base/dists/erlang/cdf';
import exponential from './../../base/dists/exponential/cdf';
import f from './../../base/dists/f/cdf';
import frechet from './../../base/dists/frechet/cdf';
import gamma from './../../base/dists/gamma/cdf';
import gumbel from './../../base/dists/gumbel/cdf';
import invgamma from './../../base/dists/invgamma/cdf';
import kumaraswamy from './../../base/dists/kumaraswamy/cdf';
import laplace from './../../base/dists/laplace/cdf';
import levy from './../../base/dists/levy/cdf';
import logistic from './../../base/dists/logistic/cdf';
import lognormal from './../../base/dists/lognormal/cdf';
import normal from './../../base/dists/normal/cdf';
import pareto1 from './../../base/dists/pareto-type1/cdf';
import rayleigh from './../../base/dists/rayleigh/cdf';
import t from './../../base/dists/t/cdf';
import triangular from './../../base/dists/triangular/cdf';
import uniform from './../../base/dists/uniform/cdf';
import weibull from './../../base/dists/weibull/cdf';


// MAIN //

var CDF = {};

CDF[ 'arcsine' ] = arcsine;
CDF[ 'beta' ] = beta;
CDF[ 'betaprime' ] = betaprime;
CDF[ 'cauchy' ] = cauchy;
CDF[ 'chi' ] = chi;
CDF[ 'chisquare' ] = chisquare;
CDF[ 'cosine' ] = cosine;
CDF[ 'erlang' ] = erlang;
CDF[ 'exponential' ] = exponential;
CDF[ 'f' ] = f;
CDF[ 'frechet' ] = frechet;
CDF[ 'gamma' ] = gamma;
CDF[ 'gumbel' ] = gumbel;
CDF[ 'invgamma' ] = invgamma;
CDF[ 'kumaraswamy' ] = kumaraswamy;
CDF[ 'laplace' ] = laplace;
CDF[ 'levy' ] = levy;
CDF[ 'logistic' ] = logistic;
CDF[ 'lognormal' ] = lognormal;
CDF[ 'normal' ] = normal;
CDF[ 'pareto-type1' ] = pareto1;
CDF[ 'rayleigh' ] = rayleigh;
CDF[ 't' ] = t;
CDF[ 'triangular' ] = triangular;
CDF[ 'uniform' ] = uniform;
CDF[ 'weibull' ] = weibull;


// EXPORTS //

export default CDF;
